import {
  Component,
  OnChanges,
  OnInit,
  OnDestroy,
  EventEmitter,
  Output,
  Input,
  ViewEncapsulation,
  Renderer2,
  Inject,
  ElementRef,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import {
  BlueprintContainer,
  BlueprintCollection,
  BlueprintCollectionAttribute
} from '@vex/model/blueprint-list';
import { KeyValue } from '@vex/model/base/base-model';
import { FlatTreeControl } from '@angular/cdk/tree';
import { MatTreeFlattener, MatTreeFlatDataSource } from '@angular/material/tree';
import { SelectionModel } from '@angular/cdk/collections';
import {
  TodoItemFlatNode as FeatureItemFlatNode,
  TodoItemNode as FeatureItemNode,
  TreeAttributeType
} from '@vex/model/base/tree-model';
import { cloneDeep } from 'lodash';
import { DOCUMENT } from '@angular/common';
import { Icons } from '@vex/icons/icons';
import { fadeInUp400ms } from '@vex/animations/fade-in-up.animation';
import { stagger60ms } from '@vex/animations/stagger.animation';
import { MatDialog } from '@angular/material/dialog';
import { ComplexTreeTableComponent } from '@vex/components/inventory-tree/complex-tree-table/complex-tree-table.component';
import { FetchDataService } from '@vex/http-service/fetch-data.service';
import { AttachmentService } from '@vex/http-service/attachment.service';
import { CollectionEntryService } from '@vex/http-service/collection-entry.service';
import { debounceTime, distinctUntilChanged, filter, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { FormGroup, FormArray, FormBuilder, Validators } from '@angular/forms';
import { MultipleSelectionSelectAllComponent } from '@vex/components/vex-selection/multiple-selection-select-all/multiple-selection-select-all.component';
import { FormControlVisibilityService } from '@vex/services/form-control-visibility.service';
import { DataURLCommonService } from '@vex/services/data-url-common.service';
import { AdvanceDataTypeService } from '@vex/services/advance-data-type.service';
import { PopoverService } from '@vex/components/popover/popover/popover.service';
import { InventoryTreeSettingDiagramComponent } from '@vex/components/popover/inventory-tree-setting-diagram/inventory-tree-setting-diagram.component';
import { environment } from 'app/../environments/environment';
import { BluePrintStateService } from '@vex/constants/bluepirnt-state';
import { CloudConnectStateService } from '@vex/constants/cloud-connect-state';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

declare var treeComplexPopup: any;
declare var uuid: any;

@Component({
  selector: 'inventory-tree',
  templateUrl: './inventory-tree.component.html',
  styleUrls: ['./inventory-tree.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: [stagger60ms, fadeInUp400ms]
})
export class InventoryTreeComponent extends Icons implements OnInit, OnChanges, OnDestroy {
  @Input()
  isNeedVerticalMargin: boolean = false;

  @Input()
  BlueprintContainers: BlueprintContainer[];

  @Input()
  BlueprintCollections: BlueprintCollection[];

  @Input()
  isCheckbox: boolean = true;

  @Input()
  onlyMandatory: boolean = true;

  @Input()
  allowItemClick: boolean = true;

  @Input()
  expandAllOnLoad: boolean = true;

  @Input()
  compactMode: boolean = false;

  @Input()
  showCSPFields: boolean = true;

  @Input()
  showAuditFields: boolean = true;

  @Input()
  showResourceStateLabel: boolean = true;

  @Input()
  defaultAudit: any = {};

  @Input()
  showColor: boolean = false;

  @Input()
  hideEmptyAttribute: boolean = false;

  @Input()
  startWithChild: boolean = false; // for Resource template

  @Input()
  callFrom: string = '';

  @Input()
  IsCollectionEntryAttributeId: boolean = false;

  @Input()
  isInventory: boolean = false;

  @Input()
  isBlueprint: boolean = false;

  @Input()
  isShowFilter: boolean = true;

  @Input()
  isShowDeployedServices: boolean = false;

  @Input()
  isShowStateDetail: boolean = false;

  @Input()
  inventoryId: string = '';

  @Output()
  itemClick = new EventEmitter<FeatureItemFlatNode>();

  @Output()
  valueChange = new EventEmitter();

  searchText = '';
  storeComplexData: any[] = [];
  storeFileData: any[] = [];
  isComplexPopup: boolean = false;
  isDownloadFile: boolean = false;
  data: any[] = [];
  attributesCollection: any[] = [];
  totalHit: number = 0;
  counter: number = 0;
  treeComplexPopup: any;
  isCollapse: boolean = true;
  isDetailsExpanded: boolean = false;
  isSearch: boolean = false;
  isShowUserProvider: boolean = true;
  isShowServiceProvider: boolean = true;
  isShowAudit: boolean = true;
  isShowNullValues: boolean = false;

  searchResource: string = '';
  selectedIgnoredValue: any = [];
  oldSearchResource: string = '';
  searchResources$ = new Subject<string>();
  filterResource: string[] = [];
  selectedFilterResource: string[] = [];
  resources: any[] = [];
  inventoryTreeId: any = uuid();
  filterAttribute: any = {
    IsMandatory: false,
    DisplayName: 'Resources',
    loader: false,
    Name: 'ResourceIds'
  };
  diagramSetting: any = {
    isShowUserProvider: true,
    isShowServiceProvider: true,
    isShowAudit: true,
    isShowNullValues: false
  };
  form: FormGroup;
  @ViewChild('MultipleSelectionSelectAllComponent', { static: false })
  multiAll: MultipleSelectionSelectAllComponent;
  clientUrl = environment.CLIENT_URL;
  isFetchAllData: boolean = false;
  fetchHit: number = 0;
  defaultPolicyText: string = "(Interface IP Summary should have status = 'up')";
  private destroy$ = new Subject<void>();
  externalIcon: any = `<svg
                        class="mx-1"
                        width="12"
                        height="12"
                        viewBox="0 0 512 512"
                        fill="currentColor"
                        style="display:inline-block; vertical-align:middle;"
                      >
                        <path d="M320 24a24 24 0 0 1 24-24H488a24 24 0 0 1 24 24V168a24 24 0 0 1-48 0V81.9L231 315a24 24 0 0 1-34-34L430.1 48H344a24 24 0 0 1-24-24zM0 88C0 39.4 39.4 0 88 0H200a24 24 0 0 1 0 48H88C65.9 48 48 65.9 48 88V424c0 22.1 17.9 40 40 40H424c22.1 0 40-17.9 40-40V312a24 24 0 0 1 48 0V424c0 48.6-39.4 88-88 88H88C39.4 512 0 472.6 0 424V88z"/>
                      </svg>`;
  constructor(
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document,
    private dialog: MatDialog,
    private fetchDataService: FetchDataService,
    private collectionEntryService: CollectionEntryService,
    private attachmentService: AttachmentService,
    private formBuilder: FormBuilder,
    private formControlVisibilityService: FormControlVisibilityService,
    private dataUrlCommonService: DataURLCommonService,
    private advanceDataTypeService: AdvanceDataTypeService,
    private stateService: BluePrintStateService,
    private popover: PopoverService,
    private sanitizer: DomSanitizer,
    public cloudConnectStateService: CloudConnectStateService
  ) {
    super();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    this.treeComplexPopup.clearOldData(this.inventoryTreeId);
  }

  ngOnInit() {
    this.treeComplexPopup = new treeComplexPopup(this, this.inventoryTreeId);
    this.filter(true);
    this.loadFont();
    this.onSearchResources();
    this.searchResource = '';
    this.form = this.formBuilder.group({
      ResourceIds: [[]]
    });
    this.isInitialized = true;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      this.isInitialized &&
      (changes.BlueprintContainers || changes.BlueprintCollections)
    ) {
      this.filter(true);
      setTimeout(() => {
        this.isSearch = false;
      }, 0);
    }
  }

  showPopover(origin) {
    const popoverRef = this.popover.open({
      content: InventoryTreeSettingDiagramComponent,
      origin: origin,
      offsetY: -14,
      data: {
        ...this.diagramSetting,
        callFrom: this.callFrom,
        isShowAuditToggle: this.showAuditFields
      },
      position: [
        {
          originX: 'center',
          originY: 'top',
          overlayX: 'center',
          overlayY: 'bottom'
        },
        {
          originX: 'end',
          originY: 'bottom',
          overlayX: 'end',
          overlayY: 'top'
        }
      ]
    });

    popoverRef.afterClosed$.pipe(takeUntil(this.destroy$)).subscribe((res) => {
      if (res.type == 'close') {
        if (res.data != null) {
          this.diagramSetting = res.data;
          this.isShowServiceProvider = this.diagramSetting.isShowServiceProvider;
          this.isShowUserProvider = this.diagramSetting.isShowUserProvider;
          this.isShowNullValues = this.diagramSetting.isShowNullValues;
          this.isShowAudit = this.diagramSetting.isShowAudit;
        }
        this.filter(true);
        setTimeout(() => {
          this.isSearch = false;
        }, 1000);
      }
    });
  }

  onSearchResources() {
    this.searchResources$
      .pipe(takeUntil(this.destroy$), distinctUntilChanged(), debounceTime(800))
      .subscribe(() => this.filter());
  }

  loadFont() {
    const linkElem = this.renderer.createElement('link');
    this.renderer.setAttribute(linkElem, 'rel', 'stylesheet');
    this.renderer.setAttribute(
      linkElem,
      'href',
      'https://fonts.googleapis.com/css?family=Material+Icons+Two+Tone'
    );
    this.renderer.appendChild(this.document?.head, linkElem);
  }

  private initDataChildCollection(blueprintCollections: BlueprintCollection[]) {
    this.data = [];
    this.data = this.buildFileTree(blueprintCollections, '', 0);
    this.totalHit = 0;
    this.counter = 0;
    this.fetchHit = 0;
    this.isFetchAllData = false;
    if (this.data) {
      this.data.forEach((blueprints) => {
        this.replaceIdsWIthLable(blueprints);
      });
    }
    this.isFetchAllData = true;
    if (this.data?.length == 0 || (this.isFetchAllData && this.fetchHit == this.totalHit)) {
      this.prepareData();
    }
  }

  private initDataContainer(blueprintContainers: BlueprintContainer[]) {
    this.data = [];
    this.totalHit = 0;
    this.counter = 0;
    this.fetchHit = 0;
    blueprintContainers?.forEach((container) => {
      const mappedNode: FeatureItemNode = {
        item: container.Name,
        itemCollectionEntryName: container.Name,
        children: this.buildFileTree(container.BlueprintCollections, container.Id, 1),
        ContainerId: container.Id,
        collection: container,
        deployedServices: [],
        isShowAttribute: false
      };
      this.data.push(mappedNode);
    });
    this.isFetchAllData = false;
    if (this.data) {
      this.data.forEach((blueprint) => {
        this.replaceIdsWIthLable(blueprint);
      });
    }
    this.isFetchAllData = true;
    if (this.data?.length == 0 || (this.isFetchAllData && this.fetchHit == this.totalHit)) {
      this.prepareData();
    }
  }

  replaceIdsWIthLable(blueprint) {
    let dataUriItems = blueprint.Attributes?.filter((d: any) => d.Attribute.IsDropdown) || [];
    if (dataUriItems.length > 0) {
      dataUriItems.forEach((attribute) => {
        this.manageDataUrl(attribute.Attribute, attribute);
      });
    }
    if (blueprint.children?.length > 0) {
      blueprint.children?.forEach((child) => {
        this.replaceIdsWIthLable(child);
      });
    }
  }

  set requestCompleted(val: number) {
    this.fetchHit = val;
    if (val === this.totalHit && this.isFetchAllData) {
      this.prepareData();
    }
  }

  buildFileTree(
    collections: BlueprintCollection[],
    containerId: string,
    level: number
  ): FeatureItemNode[] {
    let itemNodes: FeatureItemNode[] = [];
    collections?.sort((a, b) => (a.CollectionEntryName > b.CollectionEntryName ? 1 : -1));
    collections?.forEach(async (collection) => {
      const node = new FeatureItemNode();
      node.collection = collection;
      node.item = collection.CollectionName;
      ((node.itemCollectionEntryName = collection.CollectionEntryName || collection.CollectionName),
        (node.ContainerId = containerId));
      node.CollectionId = collection.Id;
      node.CollectionEntryId = collection.CollectionEntryId;
      node.deployedServices = collection.DeployedServices;
      node.stateDetail = collection.StateDetail;
      node.isShowAttribute = true;
      if (this.resources.findIndex((x) => x.Value == collection.CollectionEntryId) == -1) {
        this.resources.push({
          Label: collection.CollectionName,
          Value: collection.CollectionEntryId
        });
      }
      collection.BlueprintCollectionAttributes = collection.BlueprintCollectionAttributes || [];
      collection.BlueprintChildCollections = collection.BlueprintChildCollections || [];

      for (let i = 0; i < collection.BlueprintCollectionAttributes.length; i++) {
        let attribute = collection.BlueprintCollectionAttributes[i];
        if (!attribute.AttributeType) {
          attribute.AttributeType = this.advanceDataTypeService.attributeTypes.find(
            (x) => x.Id == attribute.AttributeTypeId
          );
        }
      }
      if (this.onlyMandatory) {
        node.Attributes = collection.BlueprintCollectionAttributes.filter((d) => d.IsMandatory).map(
          (d) =>
            <TreeAttributeType>{
              Id: d.Name,
              Name: d.Name,
              DisplayName: d.DisplayName,
              Value: d.Value,
              Color: d.Color,
              AttributeType: d.DataGeneratedBy,
              IsComplex: d.AttributeType ? d.AttributeType.IsComplex : false,
              IsList: d.AttributeType ? d.AttributeType.IsList : false,
              IsFile: d.AttributeType
                ? d.AttributeType.BaseType == 'file' || d.AttributeType.Name == 'Template File'
                  ? true
                  : false
                : false,
              Attribute: d
            }
        );
      } else {
        node.Attributes = collection.BlueprintCollectionAttributes.map(
          (d) =>
            <TreeAttributeType>{
              Id: d.Name,
              Name: d.Name,
              DisplayName: d.DisplayName,
              Value: d.Value,
              Color: d.Color,
              AttributeType: d.DataGeneratedBy,
              IsComplex: d.AttributeType ? d.AttributeType.IsComplex : false,
              IsList: d.AttributeType ? d.AttributeType.IsList : false,
              IsFile: d.AttributeType
                ? d.AttributeType.BaseType == 'file' || d.AttributeType.Name == 'Template File'
                  ? true
                  : false
                : false,
              Attribute: d
            }
        );
      }
      if (this.attributesCollection.findIndex((x) => x.Id == collection.Id) == -1) {
        this.attributesCollection.push(collection);
      }

      node.children =
        collection.BlueprintChildCollections.length > 0
          ? this.buildFileTree(collection.BlueprintChildCollections, containerId, level + 1)
          : [];
      itemNodes.push(node);
    });
    return itemNodes;
  }

  treeControl: FlatTreeControl<FeatureItemFlatNode>;
  treeFlattener: MatTreeFlattener<FeatureItemNode, FeatureItemFlatNode>;
  dataSource: MatTreeFlatDataSource<FeatureItemNode, FeatureItemFlatNode>;
  flatNodeMap = new Map<FeatureItemFlatNode, FeatureItemNode>();
  nestedNodeMap = new Map<FeatureItemNode, FeatureItemFlatNode>();
  /** The selection for checklist */
  checklistSelection = new SelectionModel<FeatureItemFlatNode>(true /* multiple */);
  allNodes: any[] = [];
  private isInitialized = false;

  isExpandable = (node: FeatureItemFlatNode) => node.expandable;
  getChildren = (node: FeatureItemNode): FeatureItemNode[] => node.children || [];
  hasChild = (_: number, _nodeData: FeatureItemFlatNode) => _nodeData.expandable;
  hasNoContent = (_: number, _nodeData: FeatureItemFlatNode) => _nodeData.item === '';
  getLevel = (node: FeatureItemFlatNode) => node.level;
  transformer = (node: FeatureItemNode, level: number) => {
    if (node.children && node.children.length > 0) {
      node.children = node.children.sort((a, b) => {
        const itemCompare = a.item?.localeCompare(b.item, undefined, {
          sensitivity: 'base'
        });

        if (itemCompare !== 0) {
          return itemCompare;
        }

        const classify = (v: string) => {
          if (/^\d+$/.test(v)) return 0;
          if (/^(?=.*\d)(?=.*[a-zA-Z])/.test(v)) return 1;
          return 2;
        };

        const typeA = classify(a.itemCollectionEntryName);
        const typeB = classify(b.itemCollectionEntryName);
        if (typeA !== typeB) {
          return typeA - typeB;
        }
        if (typeA === 0) {
          return Number(a.itemCollectionEntryName) - Number(b.itemCollectionEntryName); // numeric compare
        }

        return a.itemCollectionEntryName?.localeCompare(b.itemCollectionEntryName, undefined, {
          numeric: true,
          sensitivity: 'base'
        });
      });
    }
    const existingNode = this.nestedNodeMap.get(node);
    const flatNode =
      existingNode && existingNode.item === node.item ? existingNode : new FeatureItemFlatNode();
    flatNode.item = node.item;
    const nameAttribute = node.Attributes?.find((attribute) => attribute.Id === 'name');
    flatNode.ItemName =
      level != 0
        ? nameAttribute?.Value ||
          node.itemCollectionEntryName ||
          (node.Attributes?.length > 0 ? node.Attributes[0].Value : null) ||
          node.item ||
          'N/A'
        : node.item;
    flatNode.level = level;
    flatNode.expandable = !!node.children && node.children.length > 0;
    flatNode.CollectionId = node.CollectionId;
    flatNode.ContainerId = node.ContainerId;
    flatNode.CollectionEntryId = node.CollectionEntryId;
    flatNode.CreatedDate = node.collection?.CreatedDate || this.defaultAudit?.CreatedDate;
    flatNode.CreatedBy = node.collection?.CreatedBy || this.defaultAudit?.CreatedBy;
    flatNode.UpdatedDate = node.collection?.UpdatedDate || this.defaultAudit?.UpdatedDate;
    flatNode.UpdatedBy = node.collection?.UpdatedBy || this.defaultAudit?.UpdatedBy;
    flatNode.ResourceStateMessage =
      node.collection?.ResourceStateMessage || this.defaultAudit?.LastCommitMessage;
    flatNode.ResourceState =
      node.collection?.ResourceState != undefined && node.collection?.ResourceState != null
        ? node.collection.ResourceState
        : this.defaultAudit?.State;
    flatNode.IsShowAudit = node.Attributes?.length ? true : false;
    flatNode.UserAttributes = node.Attributes
      ? this.mapAttributes(
          node.Attributes.filter(
            (d) =>
              ((!this.hideEmptyAttribute || (this.hideEmptyAttribute && d.Value)) &&
                d.AttributeType === 'User') ||
              d.AttributeType === 'System'
          ),
          false,
          node.collection
        )
      : '';

    flatNode.CSPAttributes = node.Attributes
      ? this.mapAttributes(
          node.Attributes.filter((d) => d.AttributeType !== 'User' && d.AttributeType !== 'System'),
          true,
          node.collection
        )
      : '';
    flatNode.DeployedServices = node.deployedServices;
    flatNode.isShowAttribute = node.isShowAttribute;
    flatNode.DeployedServicesHtml = this.mapDeployedServices(node.deployedServices);
    flatNode.StateDetail = node.stateDetail;
    flatNode.colorStatus = this.getColorStatus(flatNode);
    flatNode.resourceState = this.getState(flatNode.ResourceState);
    flatNode.stateDetailStatus = this.getStateDetailStatus(flatNode?.StateDetail?.Status);
    this.flatNodeMap.set(flatNode, node);
    this.nestedNodeMap.set(node, flatNode);
    if (
      node.CollectionId &&
      this.allNodes.findIndex((x) => x.CollectionId == node.CollectionId) == -1
    ) {
      this.allNodes.push(node);
    }
    return flatNode;
  };

  mapDeployedServices(deployedServices: any[] = []) {
    let attributesContent = '';
    for (let i = 0; i < deployedServices?.length; i++) {
      let service = deployedServices[i];
      let attributeData = `<p class="text-primary underline  openpop" onclick="onRedirect('/network-management/jobs', '${service.Value}')"> <b>${service.Label}</b> 
      ${this.externalIcon}</p>`;
      attributesContent += `<div class="event" fxLayout="row">
                    <div class="dot primary"></div>
                    <div class="line"></div>
                    <div class="info">
                    <div class="description">${attributeData}</div>
                    </div>
                </div>`;
    }

    return this.sanitizer.bypassSecurityTrustHtml(attributesContent);
  }

  mapDevicePolicies(devicePolicies: any[] = []) {
    let attributesContent = '';
    for (let i = 0; i < devicePolicies?.length; i++) {
      let service = devicePolicies[i];
      let attributeData = `<p class="text-primary underline  openpop" onclick="onRedirect('/compliance/policy-manager-dc?id=', '${service.Value}')"> <b>${service.Label}</b>${this.externalIcon}</p>`;
      attributesContent += `<div class="event" fxLayout="row">
                    <div class="dot primary"></div>
                    <div class="line"></div>
                    <div class="info">
                    <div class="description">${attributeData}</div>
                    </div>
                </div>`;
    }

    return this.sanitizer.bypassSecurityTrustHtml(attributesContent);
  }

  mapAttributes(
    attributes: TreeAttributeType[],
    isCSPValue: boolean = false,
    collection: any = {}
  ) {
    let attributesContent = '';
    for (let i = 0; i < attributes.length; i++) {
      let attribute = attributes[i];
      let itemClass = ``;
      if (this.showColor) {
        if (attribute.Color === 'green') {
          itemClass = ` existItem `;
        } else if (attribute.Color === 'red') {
          itemClass = ` notExistItem `;
        }
      }
      if (!this.setFormControlVisibility(attribute.Attribute, attributes, false, {}, collection)) {
        continue;
      }
      if (attribute.Attribute && attribute.Attribute.AttributeType) {
        attribute.IsComplex = attribute.Attribute.AttributeType.IsComplex;
        attribute.IsList = attribute.Attribute.AttributeType.IsList;
      }
      attribute.DisplayName = attribute.Attribute.DisplayName;
      let attributeData = this.mapAttributeValue(attribute, attributes, isCSPValue, collection);
      if (!(attributeData == 'Not Assigned' && !this.isShowNullValues)) {
        attributesContent += `<div class="event" fxLayout="row">
                            <div class="dot primary"></div>
                            <div class="line"></div>
                            <div class="info ${itemClass}">
                            <div class="name">${attribute.DisplayName}</div>
                            <div class="description">${attributeData}</div>
                            </div>
                        </div>`;
      }
    }

    return this.sanitizer.bypassSecurityTrustHtml(attributesContent);
  }

  setFormControlVisibility(
    attribute,
    attributes,
    isCallFromComplex: boolean = false,
    complexData: any = {},
    collection: any = {}
  ) {
    if (!attribute.ShowExpression) {
      attribute.IsVisible = true;
      this.getAdvanceDataType(collection, attribute, isCallFromComplex, complexData);
      return true;
    } else {
      let expression = attribute.ShowExpression.replace(/}/g, '').replace(/{/g, '');
      const splittedConditions = expression.split(/[||&&]+/);
      let evalFlag = false;
      for (let i = 0; i < splittedConditions.length; i++) {
        const propertyName = this.formControlVisibilityService.getPropertyNameFromCondition(
          splittedConditions[i]
        );
        if (propertyName.indexOf('.') === -1) {
          let propertyValue = '';
          let formValue: any;
          if (isCallFromComplex) {
            formValue = complexData[propertyName];
          } else {
            formValue = attributes.find((x) => x.Id == propertyName)?.Value;
          }
          if (!formValue) {
            formValue = '';
          }
          propertyValue = "'" + formValue + "'";
          const condition = splittedConditions[i].replace(propertyName, propertyValue);
          expression = expression.replace(splittedConditions[i], condition);
          evalFlag = true;
        } else if (propertyName.indexOf('.') !== -1) {
          let propertyToFind = propertyName.split('.');
          let attributeValue = this.formControlVisibilityService.getLabelValue(
            attributes,
            propertyToFind
          );
          if (!attributeValue) {
            attributeValue = '';
          }
          let condition = splittedConditions[i].replace(propertyName, "'" + attributeValue + "'");
          expression = expression.replace(splittedConditions[i], condition);
          evalFlag = true;
        }
      }
      attribute.IsVisible = evalFlag && eval(expression);
      if (attribute.IsVisible) {
        this.getAdvanceDataType(collection, attribute, isCallFromComplex, complexData);
      }
      return attribute.IsVisible;
    }
  }

  getAdvanceDataType(collection, attribute, isCallFromComplex, complexData) {
    let object = {
      collections: this.attributesCollection,
      collection: collection,
      isComplex: isCallFromComplex,
      data: complexData,
      isInventory: this.isInventory,
      isBlueprint: this.isBlueprint
    };
    this.advanceDataTypeService.getAttributeDataTypeForValue(attribute, false, object);
  }

  manageDataUrl(
    attribute: any,
    currentItem: any = {},
    lable_key: string = 'ddLable',
    isListLable: boolean = false,
    isComplex: boolean = false
  ) {
    if (attribute.UseData) {
      currentItem[lable_key] = attribute.Value;
      return;
    }

    if (attribute.DataUrl) {
      if (this.dataUrlCommonService.isJSON(attribute.DataUrl)) {
        let object: any = {};
        this.dataUrlCommonService.parseDataUrl(attribute, object, (type) => {
          if (type == 'hit') {
            this.totalHit++;
          }
          if (type == 'fetch') {
            this.requestCompleted = ++this.counter;
          }
        });
      } else {
        attribute.DataUrlData = [];
        let urlData = attribute.DataUrl.split(':')[1];
        const pattern = /{.+\w+}/;
        let isValidUrl = true;
        //this will show plus button besides of dropdown
        attribute.ShowAddButton = false;
        attribute['table'] = false;
        if (
          attribute.DataUrl.split(':')[0] == 'url' ||
          attribute.DataUrl.split(':')[0] == 'url+' ||
          attribute.DataUrl.split(':')[0] == 'url-table'
        ) {
          if (attribute.DataUrl.split(':')[0] == 'url-table') {
            attribute['table'] = true;
          }
          let needEmptyData: boolean = true;
          if (pattern.test(urlData)) {
            if (urlData.includes('{InventoryId}')) {
              urlData = urlData.replaceAll('{InventoryId}', this.inventoryId);
              let inventoryParameters = urlData.split('/');
              let terraformResourceName = inventoryParameters[inventoryParameters.length - 1];
              this.getDiagramData(attribute, terraformResourceName);
              needEmptyData = false;
            }
            const parameters = urlData.split('/').filter((m) => pattern.test(m));
            parameters.forEach((m) => {
              let parameterValue = m.replace('{', '').replace('}', '');
              let result = '';
              let attributeProperty = parameterValue.split('.');
              const collectionName = attributeProperty[0];
              const attibuteName = attributeProperty[1];
              if (attributeProperty.length == 1) {
                if (currentItem !== undefined) {
                  if (isComplex) {
                    result = currentItem[collectionName];
                  } else {
                    result = currentItem.Value;
                  }
                }
              } else {
                if (!this.startWithChild) {
                  this.BlueprintContainers.forEach((container) => {
                    container.BlueprintCollections.forEach((collection) => {
                      result = this.findAttribute(
                        collection,
                        collectionName,
                        attibuteName,
                        attributeProperty
                      );
                    });
                  });
                } else {
                  this.BlueprintCollections.forEach((collection) => {
                    result = this.findAttribute(
                      collection,
                      collectionName,
                      attibuteName,
                      attributeProperty
                    );
                  });
                }
              }

              if (!result) {
                this.attributesCollection
                  .filter((collection) => collection.ResourceName == collectionName)
                  .forEach((collection) => {
                    let attr = collection.BlueprintCollectionAttributes.find(
                      (x) => x.Name == attibuteName
                    );
                    if (attr) {
                      if (attributeProperty.length == 2) {
                        result = attr.Value;
                        return result;
                      }
                      let last_resource: any;
                      if (attr.AttributeType?.IsList) {
                        last_resource = this.dataUrlCommonService.getValidJsonValue(
                          attr.Value,
                          attr.Name
                        );
                      } else if (attr.AttributeType?.IsComplex) {
                        let resource = this.dataUrlCommonService.getValidJsonValue(
                          attr.Value,
                          attr.Name
                        );
                        if (resource[attr.Name]?.length) last_resource = resource[attr.Name][0];
                      } else {
                        last_resource = attr.Value;
                      }
                      for (var i = 2; i < attributeProperty.length; i++) {
                        if (i == attributeProperty.length - 1) {
                          let key_name = attributeProperty[attributeProperty.length - 1];
                          if (last_resource) result = last_resource[key_name];
                          return result;
                        } else last_resource = attr[0];
                      }
                    }
                  });
              }

              if (!result) {
                isValidUrl = false;
              }
              urlData = urlData.replace(m, result);
            });
          }
          if (urlData && isValidUrl) {
            attribute['tableFilter'] = [];
            this.totalHit++;
            this.fetchDataService.getByUrl(urlData).pipe(takeUntil(this.destroy$)).subscribe(
              (response) => {
                if (needEmptyData) {
                  attribute.DataUrlData = [];
                }
                if (response) {
                  response.forEach((m, mi) => {
                    if (!(m instanceof Object)) {
                      attribute.DataUrlData.push({ Label: m, Value: m });
                    } else {
                      if (attribute['table']) {
                        if (mi == 0) {
                          attribute['DataUrlHeading'] = Object.keys(m);
                          const index = attribute['DataUrlHeading'].indexOf('Value');
                          if (index > -1) {
                            attribute['DataUrlHeading'].splice(index, 1);
                          }
                        }
                        m['isSelected'] = false;
                        if (
                          attribute.Value != null &&
                          attribute.Value != '' &&
                          m.Value == attribute.Value
                        )
                          m['isSelected'] = true;
                        attribute.DataUrlData.push(m);
                      } else attribute.DataUrlData.push(m);
                    }
                    attribute['tableFilter'] = attribute.DataUrlData;
                  });
                }
                let label = attribute.DataUrlData.find((dd) => dd.Value == attribute.Value || dd.SourceBlueprintCollectionId == attribute.Value);
                if (label !== undefined) {
                  currentItem[lable_key] = label.Label;
                  if (label.Redirect) {
                    currentItem['Redirect'] = label.Redirect;
                    currentItem['RedirectReference'] = label.RedirectReference;
                  }
                } else currentItem[lable_key] = attribute.Value;
                if (isListLable) {
                  let items = [];
                  currentItem[attribute.Name]?.forEach((item) => {
                    let name = item;
                    let itemLabel = attribute.DataUrlData.find((dd) => dd.Value == item || dd.SourceBlueprintCollectionId == item);
                    if (itemLabel) {
                      name = itemLabel.Label;
                    }
                    items.push(name);
                  });
                  currentItem[attribute.Name] = items;
                }
                this.requestCompleted = ++this.counter;
              },
              (error) => {
                this.requestCompleted = ++this.counter;
              }
            );
          }
        } else if (attribute.DataUrl.split(':')[0] == 'diagram') {
          let terraformResourceNames = urlData.split(';');
          if (terraformResourceNames && terraformResourceNames.length > 1) {
            for (let i = 0; i < terraformResourceNames.length; i++) {
              var resourceName = terraformResourceNames[i].split('.')[0];
              this.getDiagramData(attribute, resourceName);
            }
          } else {
            var resourceName = urlData.split('.')[0];
            this.getDiagramData(attribute, resourceName);
          }
          if (!attribute.AttributeType?.IsList) {
            let label = attribute.DataUrlData.find((dd) => dd.Value == attribute.Value || dd.SourceBlueprintCollectionId == attribute.Value);
            if (label !== undefined) {
              currentItem[lable_key] = label.Label;
            } else if (attribute.Value) {
              currentItem[lable_key] = attribute.Value;
            } else {
              currentItem[lable_key] = 'Not Assigned';
            }
          } else if (attribute.AttributeType?.IsList) {
            if (currentItem[attribute.Name] && currentItem[attribute.Name].length > 0) {
              let data: any[] = [];
              currentItem[attribute.Name].forEach((value) => {
                let label = attribute.DataUrlData.find((label) => label.Value == value || label.SourceBlueprintCollectionId == value);
                if (label) value = label.Label;
                data.push(value);
              });
              currentItem[attribute.Name] = data;
            }
          }
        } else if (attribute.DataUrl.split(':')[0] == 'label-dropdown') {
          let attributeProperty = urlData.split('.');
          const collectionName = attributeProperty[0];
          const attibuteName = attributeProperty[1];
          if (this.attributesCollection !== undefined) {
            this.attributesCollection
              .filter((m) => m.ResourceName == collectionName)
              .forEach((resource) => {
                let attr = resource.BlueprintCollectionAttributes.find(
                  (x) => x.Name == attibuteName
                );
                if (attr && attr.Value) {
                  if (attr.AttributeType?.IsComplex || attr.AttributeType?.IsList) {
                    attr = this.dataUrlCommonService.getValidJsonValue(attr.Value, attr.Name);
                    attr = attr[attibuteName];
                  }
                } else {
                  return;
                }
                let last_resource: any = attr;
                for (var i = 2; i < attributeProperty.length; i++) {
                  if (i == attributeProperty.length - 1) {
                    last_resource.forEach((element) => {
                      let key_name = attributeProperty[attributeProperty.length - 1];
                      attribute.DataUrlData.push({
                        Label: element[key_name],
                        Value: element[key_name]
                      });
                    });
                    return;
                  } else last_resource = attr[0];
                }
              });
          }

          let label = attribute.DataUrlData.find((dd) => dd.Value == attribute.Value || dd.SourceBlueprintCollectionId == attribute.Value);
          if (label !== undefined) {
            currentItem[lable_key] = label.Label;
          } else if (attribute.Value) {
            currentItem[lable_key] = attribute.Value;
          } else {
            currentItem[lable_key] = 'Not Assigned';
          }
        } else if (attribute.DataGeneratedBy == 'CSP' && attribute.IsParentProperty == true) {
          let terraformResourceNames = attribute.DataUrl.split(';');
          if (terraformResourceNames && terraformResourceNames.length > 1) {
            for (let i = 0; i < terraformResourceNames.length; i++) {
              var resourceName = terraformResourceNames[i];
              this.getDiagramData(attribute, resourceName);
            }
          } else {
            var resourceName = attribute.DataUrl.split('.')[0];
            this.getDiagramData(attribute, resourceName);
          }
          if (!attribute.AttributeType?.IsList) {
            let label = attribute.DataUrlData.find((dd) => dd.Value == attribute.Value || dd.SourceBlueprintCollectionId == attribute.Value);
            if (label !== undefined) {
              currentItem[lable_key] = label.Label;
            } else {
              currentItem[lable_key] = 'Referenced from Parent';
            }
          } else if (attribute.AttributeType?.IsList) {
            if (currentItem[attribute.Name] && currentItem[attribute.Name].length > 0) {
              let data: any[] = [];
              currentItem[attribute.Name].forEach((value) => {
                let label = attribute.DataUrlData.find((label) => label.Value == value || label.SourceBlueprintCollectionId == value);
                if (label) value = label.Label;
                data.push(value);
              });
              currentItem[attribute.Name] = data;
            }
          }
        } else {
          let label = attribute.DataUrlData.find((dd) => dd.Value == attribute.Value || dd.SourceBlueprintCollectionId == attribute.Value);
          if (label !== undefined) {
            currentItem[lable_key] = label.Label;
          } else if (attribute.Value) {
            currentItem[lable_key] = attribute.Value;
          } else {
            currentItem[lable_key] = 'Not Assigned';
          }
        }
      }
    }
  }

  getState(state: number) {
    return this.stateService.getState(state);
  }

  getInventoryState(state: number) {
    return this.cloudConnectStateService.getConfigurationState(state);
  }

  getDiagramData(attribute, resourceName) {
    if (this.attributesCollection !== undefined) {
      this.attributesCollection
        ?.filter((m) => m.ResourceName == resourceName)
        .forEach((collection, index) => {
          let BlueprintCollectionAttributeName = collection.BlueprintCollectionAttributes.find(
            (x) => x.Name.toLowerCase() == 'name'
          );
          if (
            !BlueprintCollectionAttributeName &&
            collection.BlueprintCollectionAttributes.length
          ) {
            BlueprintCollectionAttributeName = collection.BlueprintCollectionAttributes[0];
          }
          if (BlueprintCollectionAttributeName) {
            collection.CollectionEntryName = BlueprintCollectionAttributeName.Value;
          } else {
            collection.CollectionEntryName = 'N/A';
          }
          attribute.DataUrlData.push({
            Label: collection.CollectionEntryName
              ? collection.CollectionEntryName
              : collection.CollectionName,
            Value: collection.Id,
            SourceBlueprintCollectionId: collection.SourceBlueprintCollectionId
          });
        });
    }
  }

  findAttribute(collection, ResourceName, attibuteName, attributeProperty) {
    let result: any;
    if (collection.ResourceName == ResourceName) {
      let attr = collection.BlueprintCollectionAttributes.find((attr) => attr.Name == attibuteName);
      if (attributeProperty.length == 2) {
        result = attr?.Value;
        return result;
      }

      let last_resource: any = attr;
      for (var i = 2; i < attributeProperty.length; i++) {
        if (i == attributeProperty.length - 1) {
          let key_name = attributeProperty[attributeProperty.length - 1];
          result = last_resource[key_name];
          return result;
        } else last_resource = attr[0];
      }
    } else {
      collection.BlueprintChildCollections?.forEach((coll) => {
        result = this.findAttribute(coll, ResourceName, attibuteName, attributeProperty);
      });
    }
    return result;
  }

  viewTable(table: string = '') {}

  mapAttributeValue(
    attribute: TreeAttributeType,
    attributes: any[] = [],
    isCSPValue: boolean = false,
    collection: any = {}
  ) {
    if (!attribute.Value) {
      if (attribute.Id == 'cidr_block' || attribute.Id == 'address_space')
        return 'Defined at Runtime';
      return 'Not Assigned';
    }
    if (!attribute.IsComplex && !attribute.IsList && !attribute.IsFile) {
      if (attribute.Attribute.IsDropdown) {
        if (attribute['Redirect']) {
          if (attribute['Redirect'] == 'Inventory') {
            return (
              '<p class="text-primary downloadFile cursor-pointer"><a href=' +
                this.clientUrl +
                '/deployment/vdc-inventory?id=' +
                attribute['RedirectReference'] +
                ' target="_blank">' +
                attribute['ddLable'] || attribute['Value'] + '</a></p>'
            );
          }
        }
        return attribute['ddLable'] || attribute['Value'];
      }
      if (attribute.Attribute?.AttributeType?.Name == 'Password') return '******';
      return attribute.Value;
    } else if (attribute.IsFile) {
      if (attribute.Value && attribute.Value != '') {
        this.storeFileData.push(attribute.Value);
        return (
          '<p class="text-primary downloadFile cursor-pointer underline  ' +
          (this.storeFileData.length - 1) +
          '" onclick="onClickDownload(' +
          (this.storeFileData.length - 1) +
          ", '" +
          this.inventoryTreeId +
          '\')">Click to download</p>'
        );
      }
      return 'Not Assigned';
    } else {
      var finalValue = attribute.Value.replace(/'/g, '"');
      if (finalValue == 'None') {
        if (attribute.Id == 'cidr_block' || attribute.Id == 'address_space')
          return 'Defined at Runtime';
        return 'Not Assigned';
      }
      let parsedValue = this.dataUrlCommonService.getValidJsonValue(
        attribute.Value,
        attribute.Name
      );
      let value = parsedValue[attribute.Id];
      if (value && value.length > 0) {
        if (attribute.IsList) {
          let stringHtml = '';
          if (value)
            if (attribute.Attribute.IsDropdown) {
              value.forEach((item) => {
                let lable = '';
                if (attribute.Attribute.DataUrlData?.length == 0) {
                  this.manageDataUrl(attribute.Attribute, attribute);
                }
                if (attribute.Attribute.DataUrlData) {
                  lable = attribute.Attribute.DataUrlData.find((d) => d.Value === item || d.SourceBlueprintCollectionId == item)?.Label || item;
                } else {
                  lable = item;
                }
                if (attribute.Attribute.RedirectUrl) {
                  stringHtml += `<li class="text-primary underline  openpop" onclick="onRedirect('${attribute.Attribute.RedirectUrl}', '${item}')"> <b>${lable}</b>${this.externalIcon}</li>`;
                } else {
                  stringHtml += `<li> <b>${lable}</b> </li>`;
                }
              });
            } else {
              value.forEach((item) => {
                const displayValue = item == null || item === 'null' ? 'N/A' : item;
                stringHtml += `<li><b>${displayValue}</b></li>`;
              });
            }
          return stringHtml;
        } else if (attribute.IsComplex) {
          if (value && value.length > 0 && value[0]) {
            this.storeComplexData.push({
              name: attribute.Name,
              data: value,
              attribute: attribute,
              attributes: attributes,
              isCSPValue: isCSPValue,
              collection: collection
            });
            let html =
              '<p class="openpop ' +
              (this.storeComplexData.length - 1) +
              '" onclick="onClickPopup(' +
              (this.storeComplexData.length - 1) +
              ", '" +
              this.inventoryTreeId +
              '\')"> View ' +
              attribute.DisplayName +
              '</p>';
            return html;
          } else {
            if (attribute.Id == 'cidr_block' || attribute.Id == 'address_space')
              return 'Defined at Runtime';
            return 'Not Assigned';
          }
        }
      } else {
        return 'Not Assigned';
      }
    }
  }

  hasNoResults() {
    const hasActiveSearch =
      (this.searchResource && this.searchResource.trim() !== '') ||
      (this.selectedFilterResource && this.selectedFilterResource.length > 0);
    return (
      hasActiveSearch &&
      !!this.dataSource &&
      (!this.dataSource.data || this.dataSource.data.length === 0)
    );
  }

  prepareData() {
    let data: FeatureItemNode[] = this.data;
    this.treeFlattener = new MatTreeFlattener(
      this.transformer,
      this.getLevel,
      this.isExpandable,
      this.getChildren
    );
    this.treeControl = new FlatTreeControl<FeatureItemFlatNode>(this.getLevel, this.isExpandable);
    this.dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
    this.dataSource.data = data;
    const hasActiveSearch =
      (this.searchResource && this.searchResource.trim() !== '') ||
      (this.selectedFilterResource && this.selectedFilterResource.length > 0);
    this.isSearch = false;
    this.collapseValue(hasActiveSearch);
    this.collapseData(this.expandAllOnLoad || hasActiveSearch);
  }

  collapseValue(status: boolean = false) {
    this.isDetailsExpanded = status;
    this.treeControl.dataNodes?.forEach((node) => {
      node.isCSPExpanded = status;
      node.isUserExpanded = status;
      node.isAuditExpanded = status;
      node.isDeployedServiceExpanded = status;
      node.isDetailsExpanded = status;
    });
  }

  collapseNodeValue(node: FeatureItemFlatNode, status: boolean = false) {
    const nodes = [node, ...this.treeControl.getDescendants(node)];
    nodes.forEach((item) => {
      item.isCSPExpanded = status;
      item.isUserExpanded = status;
      item.isAuditExpanded = status;
      item.isDeployedServiceExpanded = status;
      item.isDetailsExpanded = status;
    });
  }

  collapseData(status: boolean = false) {
    if (status) {
      this.treeControl.expandAll();
    } else {
      this.treeControl.collapseAll();
    }
    this.isCollapse = status;
  }

  collapseNodeData(node: FeatureItemFlatNode, status: boolean = false) {
    if (status) {
      this.treeControl.expand(node);
      this.treeControl.expandDescendants(node);
    } else {
      this.treeControl.collapseDescendants(node);
      this.treeControl.collapse(node);
    }
  }

  complexTablePopup(tableData) {
    this.dialog
      .open(ComplexTreeTableComponent, {
        maxWidth: '100vw',
        maxHeight: '100vh',
        width: '80%',
        data: {
          inventoryId: this.inventoryId,
          data: tableData,
          manageDataUrl: this.manageDataUrl,
          destroy$: this.destroy$,
          BlueprintContainers: this.BlueprintContainers,
          BlueprintCollections: this.BlueprintCollections,
          findAttribute: this.findAttribute,
          totalHit: this.totalHit,
          fetchDataService: this.fetchDataService,
          counter: this.counter,
          requestCompleted: this.requestCompleted,
          attributesCollection: this.attributesCollection,
          startWithChild: this.startWithChild,
          getDiagramData: this.getDiagramData,
          setFormControlVisibility: this.setFormControlVisibility,
          getAdvanceDataType: this.getAdvanceDataType,
          formControlVisibilityService: this.formControlVisibilityService,
          dataUrlCommonService: this.dataUrlCommonService,
          advanceDataTypeService: this.advanceDataTypeService,
          collectionEntryService: this.collectionEntryService
        }
      })
      .afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe((r) => {});
  }

  ngAfterViewChecked() {}
  
  onResourceToggle(node) {
      setTimeout(() => {
          const isExpanded = this.treeControl.isExpanded(node);
          if (!isExpanded) {
              this.collapseNodeAndChildren(node);
          } else {
              this.itemClick.emit(node);
          }
      });
  }

  collapseNodeAndChildren(node) {
      const nodes = [node, ...this.treeControl.getDescendants(node)];

      nodes.forEach(n => {
          n.isDetailsExpanded = false;

          n.isUserExpanded = false;
          n.isCSPExpanded = false;
          n.isAuditExpanded = false;
          n.isDeployedServiceExpanded = false;
      });
  }

  getFile(Id) {
    this.attachmentService.getAttachmentGetById(Id).pipe(takeUntil(this.destroy$)).subscribe((image) => {
      if (image != undefined && image != null) {
        let extensionArr = image.Path.split('.');
        let extension = extensionArr[extensionArr.length - 1];
        var a = document.createElement('a');
        a.href = image.Path;
        a.download = image.Name + '.' + extension;
        window.open(a.href, '_blank');
        this.isDownloadFile = false;
      }
    });
  }

  onChangeResourcefilter(value) {
    this.filterResource = value;
    this.filter(false);
  }

  filter(isOtherChange: boolean = false) {
    let search = this.searchResource.toLowerCase();
    if (
      JSON.stringify(this.filterResource) != JSON.stringify(this.selectedFilterResource) ||
      search != this.oldSearchResource.toLowerCase() ||
      isOtherChange
    ) {
      this.isSearch = true;
      this.selectedFilterResource = JSON.parse(JSON.stringify(this.filterResource));
      this.oldSearchResource = search;
      if (!this.startWithChild) {
        let copyContainer = cloneDeep(this.BlueprintContainers);
        if (this.selectedFilterResource.length != 0 || search != '') {
          copyContainer?.forEach((container) => {
            let col = [];

            container.BlueprintCollections?.forEach((collection) => {
              let result = this.searchCollection(collection, search.toLowerCase());
              if (result) {
                col.push(result);
              }
            });
            container.BlueprintCollections = col;
          });
          copyContainer = copyContainer?.filter(
            (container) => container.BlueprintCollections?.length > 0
          );
        }
        this.initDataContainer(copyContainer);
      } else {
        let copyContainer = cloneDeep(this.BlueprintCollections);
        if (this.selectedFilterResource.length != 0 || search != '') {
          copyContainer = copyContainer
            ?.map((container) => this.searchCollection(container, search.toLowerCase()))
            .filter((container) => container);
        }
        this.initDataChildCollection(copyContainer);
      }
    }
  }

  matchesAttributes(collection: BlueprintCollection, searchText: string): boolean {
    if (!collection.BlueprintCollectionAttributes) return false;

    let keyValueMatching = false;
    let node = this.allNodes.find((x) => x.CollectionId == collection.Id);
    if (node) {
      keyValueMatching = node.Attributes.some(
        (attr) =>
          attr?.Value?.toString().toLowerCase().includes(searchText) ||
          attr?.ddLable?.toString().toLowerCase().includes(searchText)
      );

      if (!keyValueMatching) {
        let listItem = node.Attributes.filter((x) => x.IsList);
        if (listItem.length > 0) {
          for (let i = 0; i < listItem.length; i++) {
            let attribute = listItem[i];
            let parsedValue = this.dataUrlCommonService.getValidJsonValue(
              attribute.Value,
              attribute.Name
            );
            let value = parsedValue[attribute.Name];
            if (value && value.length > 0) {
              if (attribute.Attribute.IsDropdown) {
                for (let j = 0; j < value.length; j++) {
                  if (attribute.Attribute.DataUrlData) {
                    let label = attribute.Attribute.DataUrlData.find(
                      (d) => d.Value === value[i] || d.SourceBlueprintCollectionId == value[i]
                    )?.Label;
                    if (label?.toLowerCase().includes(searchText)) {
                      keyValueMatching = true;
                      break;
                    }
                  }
                }
              }
            }
            if (keyValueMatching) {
              break;
            }
          }
        }
      }
    }

    return (
      keyValueMatching ||
      collection.BlueprintCollectionAttributes.some((attr) =>
        attr?.Value?.toString().toLowerCase().includes(searchText)
      )
    );
  }

  searchCollection(collection: BlueprintCollection, searchText: string) {
    const originalChildren = cloneDeep(collection.BlueprintChildCollections || []);
    let filteredCollection = [];
    originalChildren?.forEach((c) => {
        if (c.BlueprintChildCollections) {
            let result = this.searchCollection(c, searchText);
            if (result) {
                filteredCollection.push(result);
            }
        }
    });

    collection.BlueprintChildCollections = filteredCollection;
    if(collection.BlueprintChildCollections.length > 0) {
        return collection;
    }
    
    let nameMatches = false;
    if(searchText) {
      nameMatches =
        collection.CollectionEntryName
          ?.replace(/\n/g, '')
          .toLowerCase()
          .includes(searchText)
        ||
        collection.CollectionName
          ?.replace(/\n/g, '')
          .toLowerCase()
          .includes(searchText);
      }

    let attributeMatches = false;
    if(searchText) {
        attributeMatches = this.matchesAttributes(collection, searchText);
    }

    let resourceMatches =
        this.selectedFilterResource.length === 0 ||
        this.selectedFilterResource.findIndex((x) => x == collection.CollectionEntryId) > -1;
    
    
    if(searchText && this.selectedFilterResource.length === 0) {
        if(nameMatches || attributeMatches) {
            return collection;
        }
    } else if(searchText && this.selectedFilterResource.length > 0) {
        if(resourceMatches && (nameMatches || attributeMatches)) {
            return collection;
        }
    } else if(this.selectedFilterResource.length > 0) {
        if(resourceMatches) {
            return collection;
        }
    }

    return null;
  }
  
  expandView(node, fieldName: string) {
    node[fieldName] = !node[fieldName];
  }

  nodeClick(node) {
    if (node?.expandable && this.treeControl) {
      this.treeControl.toggle(node);
    }
    this.itemClick.emit(node);
  }

  onReset() {
    this.searchResource = '';
    this.filterResource = [];
    if (this.multiAll) {
      this.multiAll.formMultiCtrl.setValue(this.filterResource);
      this.multiAll.mySelections = this.filterResource;
      this.multiAll.oldValue = this.filterResource;
    }
    this.filter(true);
  }

  getColorStatus(node) {
    let status: boolean = false;
    let searchText = this.searchResource.toLowerCase();
    if (this.selectedFilterResource.length != 0 || searchText != '') {
      let ddSearch: boolean = true;
      if (this.selectedFilterResource.length > 0) {
        ddSearch = this.selectedFilterResource.findIndex((x) => x == node.CollectionEntryId) > -1;
      }
      let textSearch: boolean = true;
      if (searchText != '') {
        const collectionNode = this.allNodes.find((x) => x.CollectionId == node.CollectionId);
        const collection = collectionNode?.collection;
        const itemName = node.ItemName?.toLowerCase() || '';
        const collectionEntryName =
          collection?.CollectionEntryName?.replace(/\n/g, '').toLowerCase() || '';
        const collectionName =
          collection?.CollectionName?.toLowerCase() || '';
          const attributeMatches = collection
          ? this.matchesAttributes(collection, searchText)
          : false;
        textSearch =
          collectionName.includes(searchText) ||
          itemName.includes(searchText) ||
          collectionEntryName.includes(searchText) ||
          attributeMatches;
      }
      status = ddSearch && textSearch;
    }
    return status;
  }

  openPolicyDetail(policyId: any) {
    window.open('/compliance/policy-manager-dc?id=' + policyId, '_blank');
  }

  openBenchmarkDetail(benchmarkId: any) {
    window.open('/compliance/benchmarks-dc?id=' + benchmarkId, '_blank');
  }

  getStateDetailStatus(state?: number) {
    return this.cloudConnectStateService.getDeviceState(state);
  }
}
